import React from "react";
import { Box, Button } from "@material-ui/core";
import { downloadCSV } from "../utils/csv";

export default function ExportButtons({ filename, rows, onPrint }){
  return (
    <Box display="flex" gridGap={8} flexWrap="wrap">
      <Button
        variant="outlined"
        size="small"
        onClick={()=>downloadCSV(filename, rows || [])}
        disabled={!rows || !rows.length}
      >
        Exportar CSV
      </Button>
      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={onPrint}
      >
        Imprimir / PDF
      </Button>
    </Box>
  );
}
